/* eslint-disable react-hooks/exhaustive-deps */
/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-07-25 10:07:54
 *
 *******************************************************/
import React, { useEffect, useState } from 'react';
import { Button } from '@shopify/polaris';
import { getShop } from 'src/helpers';
import { MobileCancelMajor } from '@shopify/polaris-icons';
import imageBanner from 'src/assets/images/banners/promote-custom-merchandising.png';
import arrowRight from 'src/assets/images/common/arrow-right-minor.png';

const BannerCustom = props => {
  const { title, children, action, actionContent, idDismiss = 'Banner' } = props;

  const [active, setActive] = useState(true);

  const dismissBanner = () => {
    try {
      localStorage.setItem(`${getShop()}-${idDismiss}`, true);
    } catch (error) {}
    setActive(false);
  };

  useEffect(() => {
    // Check show info banner
    let dismiss = false;
    try {
      dismiss = localStorage.getItem(`${getShop()}-${idDismiss}`);
    } catch (error) {}

    // If the banner is dismissed, hide it
    if (dismiss === 'true') {
      setActive(false);
    }
  }, []);

  return (
    active && (
      <div className="iswWithResultTabCustomBanner pfs-app-banner pfs-app-banner--success">
        <div className="pfs-banner-dismiss">
          <Button onClick={dismissBanner} icon={MobileCancelMajor} plain />
        </div>
        <div className="pfs-banner-infos">
          {/* Render title banner */}
          {title && <div className="title">{title}</div>}
          {/* Render infos banner */}
          <div className="pfs-banner-detail">
            <div style={{ width: `70%` }} className="pfs-banner-content">
              {/* render child */}
              {children}
              <div className="isw-banner-custom-actions">
                <Button primary onClick={action}>
                  <img src={arrowRight} alt="action-icon-primary" />
                  {actionContent}
                </Button>
              </div>
            </div>
            {/* Render image banner if exist image */}
            <div className="image">
              <img src={imageBanner} alt="pfs-banner-img" />
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default BannerCustom;
